import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaStar,
  FaFilm,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const DocumentaryVideoServicesInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Documentary Video Services in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Tell Your Story</Subheading>}
        heading={
          <Heading>
            Professional{" "}
            <span tw="text-primary-500">Documentary Video Services</span> in Al
            Barsha
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, our documentary video services in **Al Barsha**
            craft compelling, cinematic narratives that inform, inspire, and
            engage. From personal stories to corporate histories, we produce
            high-quality documentaries that resonate with audiences and preserve
            meaningful moments.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1551966775-a4ddc8df052b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Professional camera setup
          "https://images.unsplash.com/photo-1485846234645-a62644f84728?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Cinematic storytelling
          "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Director on set
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Documentary"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Documentary Video Production in Al Barsha"
        description="We create documentaries that captivate and convey powerful stories."
        cards={[
          {
            icon: <FaFilm color="#ff5464" size={40} />,
            title: "Cinematic Storytelling",
            description: "Engaging narratives that evoke emotion and insight.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "High-Quality Visuals",
            description:
              "Stunning footage with professional production values.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Efficient Production",
            description: "Timely delivery to meet your project deadlines.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Multi-Platform Ready",
            description:
              "Content optimized for festivals, streaming, or social media.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Professionals",
            description: "Al Barsha’s choice for documentary filmmaking.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Comprehensive Service",
            description: "From research to final edit, we handle every detail.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Documentary Video Production Process"
        description={
          <Description>
            We bring your story to life through a meticulous, creative process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Research: Dive deep into your story, goals, and audience.</li>
              <li>
                Planning: Develop a detailed script or outline for the
                narrative.
              </li>
              <li>
                Filming: Capture authentic footage with professional equipment.
              </li>
              <li>
                Interviews: Record compelling testimonials or expert insights.
              </li>
              <li>
                Post-Production: Edit with sound design, music, and visual
                effects.
              </li>
              <li>
                Delivery: Provide a polished documentary ready for your
                platform.
              </li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1540655037529-dec987208707?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Filmmaking equipment
          "https://images.unsplash.com/photo-1633080413606-2c21b92bd7b8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Video editing process
          "https://images.unsplash.com/photo-1470790376778-a9e6b6a93fa3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Creative production setup
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Documentary Wins in Al Barsha"
        description="Our documentaries have inspired audiences and driven impact."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Community Story",
            description: "Produced a documentary highlighting local culture.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Corporate Legacy",
            description: "Created a film celebrating a company’s milestone.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Praise",
            description: "96% satisfaction from documentary clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Share Your Story?</Subheading>}
        heading="Documentary Video Services in Al Barsha"
        description={
          <Description>
            Partner with MilaajBrandset for professional documentary video
            services in Al Barsha. Create cinematic, impactful films that inform
            and inspire—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Authentic documentary moment
          "https://images.unsplash.com/photo-1560474451-dc18a9c78a5c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Professional camera work
          "https://images.unsplash.com/photo-1517799094725-e3453440724e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Documentary filming scene
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
